<template>
  <tiny-modal max-width="500px">
    <template #button="{ open }">
      <div @click="open">
        <slot />
      </div>
    </template>
    <template #default="{ close }">
      <div class="border-2 border-ambi-red p-7 relative" style="border-radius: inherit">
        <!-- <div
          class="absolute inset-0 flex items-center justify-center opacity-5"
          style="z-index: -1"
        >
          <aw-icon icon="logo" id="AmbiLogo" class="text-ambi-red" style="scale: 2.5" />
        </div> -->

        <div class="mb-12">
          <h3 class="text-h3 mb-4">Jak si přejete stáhnout elektronický poukaz?</h3>
          <p>Vyberte si prosím, zda chcete na poukázce zobrazit cenu, nebo ne.</p>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div
            @click="downloadVoucher(close, this.link)"
            class="Btn -Secondary -Large w-full justify-center"
            download
          >
            S cenou
            <aw-icon icon="download" class="w-5 h-5 ml-auto"></aw-icon>
          </div>
          <div
            @click="downloadVoucher(close, this.linkWoPrice)"
            class="Btn -Secondary -Large w-full justify-center"
            download
          >
            Bez ceny
            <aw-icon icon="download" class="w-5 h-5 ml-auto"></aw-icon>
          </div>
        </div>
      </div>
    </template>
  </tiny-modal>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      required: true
    },
    linkWoPrice: {
      type: String,
      required: true
    }
  },

  methods: {
    downloadVoucher(close, link) {
      window.location.href = link
      setTimeout(() => {
        close()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped></style>
